import { Box } from '@act/storybook';
import { CardContent } from '@mui/material';
import React from 'react';

export interface InfoCardContentProps {
  children: React.ReactNode;
  backgroundColor?: string;
  borderRadius?: number | string;
  margin?: number | string;
}

/**
 * InfoCardContent renders the standard padded content section inside an info card.
 * @param props - Content and optional surface styling for specialized sections.
 * @returns A card content section.
 */
export const InfoCardContent = ({
  children,
  backgroundColor,
  borderRadius,
  margin,
}: InfoCardContentProps) => (
  <Box
    component={CardContent}
    display="block"
    fontSize="14px"
    padding="8px 16px"
    overflowWrap="break-word"
    wordBreak="break-word"
    backgroundColor={backgroundColor}
    borderRadius={borderRadius}
    margin={margin}
  >
    {children}
  </Box>
);
